// extracted by mini-css-extract-plugin
export default {"button":"Jp-z","reviewSort":"Kp-z"};